import { RootState } from "../../../../Store";

export const selectIsLicenseModalOpen = (state: RootState) =>
  state.LicenseManagementReducer?.isModalOpen ?? false;

export const selectCurrentTenantId = (state: RootState) =>
  state.LicenseManagementReducer?.currentTenantId ?? null;

export const selectIsLicenseLoading = (state: RootState) =>
  state.LicenseManagementReducer?.isLoading ?? false;

export const selectPackageNames = (state: RootState) =>
  state.LicenseManagementReducer?.packageNames ?? [];

export const selectTierOptions = (state: RootState) =>
  state.LicenseManagementReducer?.tierOptions ?? [];

export const selectPackageInfos = (state: RootState) =>
  state.LicenseManagementReducer?.packageInfos ?? [];

export const selectLicenseSettings = (state: RootState) =>
  state.LicenseManagementReducer?.licenseSettings ?? [];

export const selectSupportedFileFormats = (state: RootState) =>
  state.LicenseManagementReducer?.supportedFileFormats ?? null;

